import { HFSelectItem } from 'honeyfield-component-library';

export interface HFGroupSelectItem {
  label: string;
  selectItem: HFSelectItem[];
}
